import { Weekdays } from '../enum/cube-schema.enum';

const SECONDS_IN_MIN = 60;
const MS_IN_SEC = 1000;

export const getDayOfWeek = (dayOfWeek) => {
  return isNaN(dayOfWeek)
    ? null
    : [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
      ][dayOfWeek];
};

export const getFirstDayOfWeek = (startDateString, endDateString, weekday) => {
  const startDate = new Date(new Date(startDateString).setUTCHours(12));
  const endDate = new Date(endDateString);
  for (let day = startDate; day <= endDate; day.setDate(day.getDate() + 1)) {
    if (getDayOfWeek(day.getUTCDay()) === weekday) {
      return day;
    }
  }
  throw new Error(
    `No ${weekday} in Day Range ${startDateString} to ${endDateString}`
  );
};

export const compareDates = (a, b) => {
  if (a.date < b.date) {
    return -1;
  }
  if (a.date > b.date) {
    return 1;
  }
  return 0;
};

export const getFirstMondayString = (dateString) => {
  const date = new Date(dateString);
  const dayOfWeek = date.getDay();
  const firstMonday = date.getDate() - dayOfWeek;
  return new Date(date.setDate(firstMonday)).toISOString().slice(0, 10);
};

export const getNumberOfDaysBetweenDates = (start: Date, end: Date): number => {
  return Math.floor((end.getTime() - start.getTime()) / (1000 * 3600 * 24));
};
